<template>
  <section>
    <div class="">
      <h3>{{ $t('message.promo_code.my_vouchers') }}</h3>
    </div>
    <div class="row no-gutters">
      <div class="col-lg-8 col-12">
        <section v-if="promoCodes">
          <div v-for="(promoCode, index) in promoCodes">
            <div class="card shadow-sm" role="button" :key="index">
              <div class="d-flex flex-row rounded"
                   :class="[promoCode.disabled ? '-expired' : 'bg-info']">
                <div class="flex-fixed-width-item text-center text-white p-4 justify-content-center align-self-center">
                  <i class="fal fa-ticket fa-2x"></i>
                  <div class="mt-2">{{ $t('message.promo_code.discount') }}</div>
                </div>
                <div class="bg-white py-2 px-3 flex-grow-1">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-fill">{{ (promoCode.title) ? promoCode.title : $t('message.promo_code.title', { num: promoCode.discount })}}</div>
                    <div class="text-small text-right text-secondary flex-fill" v-if="promoCode.disabled">{{
                      $t('message.promo_code.not_available') }}
                    </div>
                    <div class="text-small text-right text-secondary flex-fill"
                         v-else-if="!promoCode.disabled && getRemainingCount(promoCode)">
                      {{ getRemainingCount(promoCode) }}
                    </div>
                  </div>
                  <div class="pt-2" v-if="promoCode.province_id || promoCode.service_id">
                    <div class="d-inline-block border border-info rounded text-small text-info px-2"
                         v-if="promoCode.service_id"
                         v-html="$options.filters.serviceParentName(promoCode.service_id, globalState.services)"></div>
                    <div class="d-inline-block border border-orange rounded text-small text-orange px-2"
                         v-if="promoCode.province_id">
                      {{ globalState.cities[promoCode.province_id] | multiLangName }}
                    </div>
                  </div>
                  <div class="pt-2">
                    <b class="mb-0">
                      {{ (promoCode.discount > 0) ? $t('message.promo_code.title', { num: promoCode.discount }) : promoCode.description }}
                    </b>
                  </div>
                  <div class="-status-alert text-small pt-2" v-if="promoCode.remark">
                    {{ promoCode.remark }}
                  </div>
                  <hr>
                  <div class="text-small"
                       :class="[promoCode.disabled ? '-status-offline' : '']">
                    {{ $t('message.promo_code.expiring') }}: {{ promoCode.expire_date | prettyOnlyDate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="text-center text-secondary p-4" v-else>
          <div class="mb-3"><i class="fal fa-ticket fa-3x"></i></div>
          <h4>{{ $t('message.promo_code.no_promo_codes') }}</h4>
        </section>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    computed: {
      ...mapState('promoCode', ['promoCodes', 'hasPromoCode']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      ...mapActions('promoCode', ['fetchPromoCodes']),
      getRemainingCount (promoCode) {
        let result = null
        let count = 0
        if (promoCode.is_one_time_code === 1) {
          count = 1
        } else if (promoCode.limit_per_user > 0) {
          count = promoCode.limit_per_user - promoCode.applied_count
        }
        if (count > 0) {
          result = this.$i18n.t('message.promo_code.remaining', { num: count })
        }
        return result
      }
    },
    mounted () {
      if (this.user) {
        const queryParams = {
          user_id: this.user.id
        }
        this.fetchPromoCodes(queryParams)
      }
    }
  }
</script>

<style scoped>
.flex-fixed-width-item {
  flex: 0 0 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Voucher.vue